import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-01639e84"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "bid-setting-history-box"
};
const _hoisted_2 = {
  class: "history-box-header"
};
const _hoisted_3 = {
  class: "title-and-count-box"
};
const _hoisted_4 = {
  class: "count-box"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "history-table-header-top"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "header-top-item"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "header-top-item user-time-stamp"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "header-top-item note"
}, "Note"), /*#__PURE__*/_createElementVNode("div", {
  class: "header-top-item growth-ambition"
}, "Growth Ambition"), /*#__PURE__*/_createElementVNode("div", {
  class: "header-top-item customer-value"
}, "Customer Value"), /*#__PURE__*/_createElementVNode("div", {
  class: "header-top-item timing-placement"
}, "Timing Placement")], -1));
const _hoisted_6 = {
  class: "history-table-header"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header-item"
}, null, -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header-item",
  style: {
    "width": "146px"
  }
}, null, -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header-item note"
}, null, -1));
const _hoisted_10 = {
  class: "header-item"
};
const _hoisted_11 = {
  class: "header-item"
};
const _hoisted_12 = {
  class: "header-item"
};
const _hoisted_13 = {
  class: "header-item"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header-item type"
}, null, -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header-item type"
}, null, -1));
const _hoisted_16 = {
  class: "history-table-content"
};
const _hoisted_17 = {
  class: "history-table-row"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "8px",
    "height": "8px",
    "aspect-ratio": "1/1",
    "border-radius": "8px",
    "background": "#DDE1E6"
  }
}, null, -1));
const _hoisted_19 = [_hoisted_18];
const _hoisted_20 = {
  class: "row-item user-and-timestamp"
};
const _hoisted_21 = {
  class: "transaction-time"
};
const _hoisted_22 = {
  class: "user-name"
};
const _hoisted_23 = {
  class: "row-item note"
};
const _hoisted_24 = {
  class: "row-item growth-ambition"
};
const _hoisted_25 = {
  class: "row-item growth-ambition"
};
const _hoisted_26 = {
  class: "row-item growth-ambition"
};
const _hoisted_27 = {
  class: "row-item growth-ambition"
};
const _hoisted_28 = {
  class: "row-item type"
};
const _hoisted_29 = {
  class: "row-item type",
  style: {
    "justify-content": "center"
  }
};
const _hoisted_30 = {
  key: 1,
  class: "activated-icons-container"
};
const _hoisted_31 = {
  key: 0,
  class: "activated-icon-box"
};
const _hoisted_32 = {
  key: 1,
  class: "activated-icon-box"
};
const _hoisted_33 = {
  key: 2,
  class: "activated-icon-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_coins_swap_icon = _resolveComponent("coins-swap-icon");
  const _component_coins_icon = _resolveComponent("coins-icon");
  const _component_CalendarIcon = _resolveComponent("CalendarIcon");
  const _component_app_popover = _resolveComponent("app-popover");
  return _openBlock(), _createBlock(_component_app_popover, {
    click: "",
    target: $props.target,
    popup: "",
    "no-arrow": "",
    "auto-width": "",
    "auto-height": "",
    placement: "bottom",
    class: "history-box",
    onPopupShown: _cache[1] || (_cache[1] = () => {
      this.$emit('shown');
    }),
    onPopupHidden: _cache[2] || (_cache[2] = () => {
      this.$emit('hidden');
    })
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createTextVNode(" Version history "), _createElementVNode("div", _hoisted_4, _toDisplayString($props.historical_settings.length), 1)]), _createVNode(_component_app_icon, {
      icon: "cross",
      size: 20,
      color: "#C9CFD4",
      style: {
        "right": "0",
        "cursor": "pointer"
      },
      onClick: _cache[0] || (_cache[0] = () => {
        this.$emit('close');
      })
    })]), _hoisted_5, _createElementVNode("div", _hoisted_6, [_hoisted_7, _hoisted_8, _hoisted_9, _createElementVNode("div", _hoisted_10, [_createVNode(_component_app_icon, {
      icon: "bid-layout-alt",
      size: 16
    })]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_app_icon, {
      icon: "bid-users-up",
      size: 16
    })]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_app_icon, {
      icon: "bid-tag",
      size: 16
    })]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_app_icon, {
      icon: "search-refactor",
      size: 16
    })]), _hoisted_14, _hoisted_15]), _createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.historical_settings, (item, index) => {
      return _openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("div", {
        class: _normalizeClass(["row-item", [{
          first: index === 0
        }, {
          last: index === $props.historical_settings.length - 1
        }, {
          only: $props.historical_settings.length === 1
        }]])
      }, _hoisted_19, 2), _createElementVNode("div", _hoisted_20, [_createElementVNode("p", _hoisted_21, _toDisplayString($options.formatDate(item.transaction_time)), 1), _createElementVNode("p", _hoisted_22, _toDisplayString((item.firstName ?? "") + " " + (item.lastName ?? "")), 1)]), _createElementVNode("div", _hoisted_23, _toDisplayString(item.notes), 1), _createElementVNode("div", _hoisted_24, _toDisplayString(Math.round(item.non_branded_keyword_targeting * 100)) + "%", 1), _createElementVNode("div", _hoisted_25, _toDisplayString(Math.round(item.competitor_product_targeting * 100)) + "%", 1), _createElementVNode("div", _hoisted_26, _toDisplayString(Math.round(item.branded_keyword_product_targeting * 100)) + "%", 1), _createElementVNode("div", _hoisted_27, _toDisplayString(Math.round(item.discovery_targeting * 100)) + "%", 1), _createElementVNode("div", _hoisted_28, [item?.bidding_type === 'ltv' ? (_openBlock(), _createBlock(_component_coins_swap_icon, {
        key: 0,
        height: 16,
        width: 16,
        color: "#E05E0F"
      })) : (_openBlock(), _createBlock(_component_coins_icon, {
        key: 1
      })), _createTextVNode(" " + _toDisplayString($options.formatBiddingType(item.bidding_type)), 1)]), _createElementVNode("div", _hoisted_29, [!item?.bid_modifier_placement && !item?.bid_modifier_seasonal && !item?.bid_modifier_hourly ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createTextVNode(" - ")], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_30, [item?.bid_modifier_placement ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createVNode(_component_app_icon, {
        icon: "layout-bottom",
        size: 12,
        color: "#056B69"
      })])) : _createCommentVNode("", true), item?.bid_modifier_seasonal ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_createVNode(_component_CalendarIcon, {
        height: 12,
        width: 12,
        color: "#056B69"
      })])) : _createCommentVNode("", true), item?.bid_modifier_hourly ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_createVNode(_component_app_icon, {
        icon: "clock",
        size: 12,
        color: "#056B69"
      })])) : _createCommentVNode("", true)]))])]);
    }), 256))])])]),
    _: 1
  }, 8, ["target"]);
}